import { Component, OnInit, OnDestroy, inject, ChangeDetectionStrategy } from '@angular/core';
import { EquipmentVariant } from '../equipment.models';
import { Subscription } from 'rxjs';
import { Theme } from '@app/support/models/theme.model';
import { ThemeService } from '@app/core/services/theme.service';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { EquipmentEventService } from '../equipment-event.service';
import { Store } from '@ngxs/store';
import { ApiGetAllSubscriptionOfferingsAction } from '@app/sales/states/customer-product/customer-product.actions';
import { HardwareVariantOfferingDetails } from '../../accessories/models/hardware-offering-model';
import { ManualRegistrationAccessoriesFormComponent } from './equipment-forms/manual-registration-accessories-form/manual-registration-accessories-form.component';
import { EquipmentDialogProductInformationComponent } from './equipment-dialog-product-information/equipment-dialog-product-information.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { EquipmentDialogHeaderComponent } from './equipment-dialog-header/equipment-dialog-header.component';

@Component({
  selector: 'app-equipment-dialog',
  templateUrl: './equipment-dialog.component.html',
  styleUrl: './equipment-dialog.component.scss',
  imports: [
    EquipmentDialogHeaderComponent,
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    EquipmentDialogProductInformationComponent,
    ManualRegistrationAccessoriesFormComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class EquipmentDialogComponent implements OnInit, OnDestroy {
  private themeService = inject(ThemeService);
  data = inject<{
    selectedEquipmentVariant: EquipmentVariant;
  }>(MAT_DIALOG_DATA);
  private equipmentEventService = inject(EquipmentEventService);
  private store = inject(Store);

  selectedTheme: Theme;

  hardwareDetails = {} as HardwareVariantOfferingDetails;

  get selectedEquipmentVariantText(): string {
    switch (this.data.selectedEquipmentVariant) {
      case EquipmentVariant.Accessory:
        return 'tilbehør';
      case EquipmentVariant.MobilePhone:
      default:
        return 'telefon';
    }
  }

  private subscriptions$: Subscription[] = [];

  private readonly defaultProductName = 'Manuell registrering';

  private get defaultProductImage(): string {
    switch (this.data.selectedEquipmentVariant) {
      case EquipmentVariant.Accessory:
        return this.selectedTheme.accessories_illustration;
      case EquipmentVariant.MobilePhone:
      default:
        return this.selectedTheme.phone_slanted_illustration;
    }
  }

  ngOnInit(): void {
    this.store.dispatch(new ApiGetAllSubscriptionOfferingsAction());

    this.subscriptions$.push(
      this.themeService.selectedTheme.subscribe(theme => {
        this.selectedTheme = theme;
        this.hardwareDetails.image ||= new Image();
        this.hardwareDetails.image.downloadUri ||= this.defaultProductImage;
        this.hardwareDetails.name ||= this.defaultProductName;
      }),

      this.equipmentEventService.hardwareDetails.subscribe(info => {
        const productNotFound = info === null;

        this.hardwareDetails = info || ({} as HardwareVariantOfferingDetails);
        this.hardwareDetails.image ||= new Image();
        this.hardwareDetails.image.downloadUri ||= this.defaultProductImage;
        const fallbackProductName = productNotFound ? 'Ukjent produkt' : this.defaultProductName;
        this.hardwareDetails.name ||= fallbackProductName;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions$.forEach(subscription => subscription.unsubscribe());
  }
}
